import React, { SVGProps } from 'react';

export const SaveMyRewardsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="19px" height="16px" viewBox="0 0 19 16" {...props}>
    <g id="Screens" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-41.000000, -228.000000)">
        <g transform="translate(20.000000, 47.000000)" />
        <g transform="translate(21.000000, 204.000000)">
          <path
            d="M34.7357193,35.3981559 L39,31.0541681 L35.6437183,31.0541681 C35.1794375,27.0975026 31.8652096,24 27.8540539,24 C23.5253836,24 20,27.5912793 20,32 C20,36.4087207 23.5253836,40 27.8532095,40 C29.4365604,40 30.9563662,39.527041 32.2445805,38.623963 L31.1469594,36.9891664 C30.1754997,37.6561951 29.0358248,38.0216242 27.8531673,38.0216242 C24.6024422,38.0216242 21.9419905,35.3114439 21.9419905,31.999957 C21.9419905,28.6884701 24.6024422,25.9782897 27.8531673,25.9782897 C30.7872221,25.9782897 33.2365604,28.171682 33.6803209,31.0541251 L30.4716075,31.0541251 L34.7357193,35.3981559 Z"
            fill={props.fill ? props.fill : Styles.color.primary}
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </svg>
);
